import type {Schemas} from 'api/dto.generated';
import type {CollectionWithoutLinks} from '../types';
import {mapCollectionTypeDto} from './mapCollectionTypeDto';

export const mapSeriesDto = (
  dto: Schemas.SeriesDto,
): CollectionWithoutLinks => {
  return {
    id: dto.id,
    collectionType: mapCollectionTypeDto(dto.type),
    titles: dto.titles,
  };
};
